import React, { useMemo, useState } from 'react';
import { Box } from '@mui/material';
import { useOutletContext } from 'react-router-dom';

import ExportFileHeader from '../../components/ExportFile/ExportFileHeader';
import ExportFileFilters from '../../components/ExportFile/ExportFileFilters';
import ExportFileTable from '../../components/ExportFile/ExportFileTable';

import styles from './ExportFile.styles';
import PageLoader from '../../../../components/loaders/PageLoader';

import { useExportLogs } from '../../hooks/useExportLogs';

const ExportFile = () => {
  const { isSidebarExpanded } = useOutletContext();
  const initialDateRange = { start: '', end: '' };

  const [dateRange, setDateRange] = useState(initialDateRange);
  const [searchQuery, setSearchQuery] = useState("");

  const { rows, loading, refreshing } = useExportLogs(dateRange);

  const filteredRows = useMemo(() => {
    return rows.filter(r => {
      // Date filter
      if (dateRange.start && r.date < dateRange.start) return false;
      if (dateRange.end && r.date > dateRange.end) return false;
      // Search filter
      if (searchQuery && searchQuery.trim() !== "") {
        const q = searchQuery.trim().toLowerCase();
        // Check if any value in the row matches the search
        const values = Object.values(r).map(v => (v !== undefined && v !== null ? String(v).toLowerCase() : ""));
        if (!values.some(val => val.includes(q))) return false;
      }
      return true;
    });
  }, [rows, dateRange, searchQuery]);

  return (
    <Box
      sx={{
        ...styles.fileContent,
        marginLeft: isSidebarExpanded ? '240px' : '95px',
        width: isSidebarExpanded ? 'calc(100vw - 240px)' : 'calc(100vw - 95px)',
        transition: 'all 0.3s ease',
      }}
    >
      {loading ? (
        <PageLoader />
      ) : (
        <>
          <ExportFileHeader
            title="Exported File Log"
            searchQuery={searchQuery}
            setSearchQuery={setSearchQuery}
            onSearch={() => {}}
          />
          <ExportFileFilters dateRange={dateRange} setDateRange={setDateRange} />
          <ExportFileTable rows={filteredRows} refreshing={refreshing} />
        </>
      )}
    </Box>
  );
};

export default ExportFile;
